export const data = [
  {
    image: 'frontClub',
    headline: 'FrontClub',
    description:
      'Videos, meetups, lectures and more. FrontClub is our community of passionate frontenders who want to share their knowledge and learn about the latest front tech.',
    color: 'white',
    link: 'https://frontclub.pl/',
  },
  {
    image: 'holacracyMeetup',
    headline: 'Holacracy<br />Meetup',
    description:
      'Make organisations great again! Every couple of months, Boldare welcomes guests from all over Europe to our HQ to discuss holacracy and share practical advice.',
    color: 'white',
    link: 'https://holacracypractitionersmeetup.splashthat.com/',
  },
  {
    image: 'ctoAsks',
    headline: 'CTO asks',
    description:
      'A few times a year, Boldare invites CTOs from around the world to our office to pass on our secrets of successful remote design & development collaboration.',
    color: 'white',
    link: '/blog/cto-asks-meetup/',
  },
];

export const sliderData = [
  {
    background: 'tealSpaceSlider',
    caption: 'Future of the workplace',
    content: 'How to create a teal space',
    description:
      '5 tips for employee-oriented companies who want to create a space supporting transparency, communication, teamwork and creativity',
    color: 'pigeon-post',
    link: '/blog/teal-space-for-creativity-and-productivity/',
  },
  {
    background: 'holaSlider',
    caption: 'Organizational change',
    content: '5 Signs You’re Ready for Holacracy',
    description:
      "Boldare's co-founder explains the qualities, which enable companies to naturally transition into a teal organization. ",
    color: 'yellow',
    link: '/blog/5-signs-you-are-ready-for-holacracy/',
  },
];
